/* CupCus — cart drawer extras: fold toggles + apply discount code without leaving the drawer.
   Delegated from document so it keeps working after the drawer re-renders via Section Rendering. */
(function () {
  var busy = false;

  function t(key, fallback) {
    return (window.theme && theme.strings && theme.strings[key]) || fallback;
  }

  function msgEl() {
    return document.querySelector('[data-cc-discount-msg]');
  }

  function setMsg(text, kind) {
    var el = msgEl();
    if (!el) return;
    el.textContent = text || '';
    el.className = 'cc-discount__msg' + (kind ? ' is-' + kind : '');
  }

  function refreshDrawer() {
    // Always ask the root URL: on a product/collection URL Shopify answers with that
    // resource's JSON instead of the requested sections.
    return fetch('/?sections=cart-drawer,cart-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var map = [
          { id: 'Cart-Drawer', selector: '.cart-drawer', html: sections['cart-drawer'] },
          { id: 'cart-drawer-toggle', selector: '.thb-item-count', html: sections['cart-bubble'] }
        ];
        map.forEach(function (part) {
          if (!part.html) return;
          var host = document.getElementById(part.id);
          if (!host) return;
          var parsed = new DOMParser().parseFromString(part.html, 'text/html');
          var fresh = parsed.querySelector(part.selector);
          var target = host.querySelector(part.selector) || host;
          if (fresh) target.innerHTML = fresh.innerHTML;
        });
      });
  }

  function applyCode(input, button) {
    var code = (input.value || '').trim();
    if (!code || busy) return;
    busy = true;
    button.disabled = true;
    setMsg('', '');

    // Shopify applies a discount code when this URL is visited; redirect to a tiny page to keep it cheap.
    fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (cart) {
        var applied = (cart.cart_level_discount_applications || []).some(function (d) {
          return (d.title || '').toUpperCase() === code.toUpperCase();
        });
        var lineApplied = (cart.items || []).some(function (i) {
          return (i.discounts || []).some(function (d) {
            return (d.title || '').toUpperCase() === code.toUpperCase();
          });
        });
        if (applied || lineApplied) {
          // Không báo trùng: sau khi refresh, theme đã hiện dòng "CODE (-$x)" ở phần tổng.
          return refreshDrawer();
        }
        setMsg(t('cartCodeInvalid', "This code isn't valid. Check the spelling and try again."), 'error');
      })
      .catch(function () {
        setMsg(t('cartCodeError', "We couldn't apply that code. Please try at checkout."), 'error');
      })
      .then(function () {
        busy = false;
        var btn = document.querySelector('[data-cc-discount-apply]');
        if (btn) btn.disabled = false;
      });
  }

  document.addEventListener('click', function (e) {
    var apply = e.target.closest('[data-cc-discount-apply]');
    if (apply) {
      var input = document.getElementById('CartDrawerDiscount');
      if (input) applyCode(input, apply);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest('#CartDrawerDiscount');
    if (!input) return;
    e.preventDefault();
    var btn = document.querySelector('[data-cc-discount-apply]');
    if (btn) applyCode(input, btn);
  });
})();
